module.exports = "/_next/static/images/fb63de8f040f046f11e5611ac3e82ce5-pen@mobile480.jpg.webp";